
import { apiRequest } from './queryClient';

export interface ProfileView {
  id: number;
  viewerUserId: number;
  viewedUserId: number;
  viewedAt: string;
  viewer: {
    id: number;
    username: string;
    category?: string;
    age?: number;
    partnerAge?: number;
    city?: string;
    about?: string;
    photos?: any[];
    photo_urls?: string[];
    profile_photo_id?: number | null;
    visibility_preferences?: string | string[];
  };
}

export async function getProfileViewers(): Promise<ProfileView[]> {
  try {
    console.log('[ProfileViews] 🔄 Chiamando API...');
    const response = await apiRequest('GET', '/api/users/profile-viewers');
    
    if (!Array.isArray(response)) {
      console.error('[ProfileViews] ❌ Risposta non è array:', response);
      return [];
    }
    
    console.log(`[ProfileViews] ✅ Ricevuti ${response.length} viewers`);
    console.log('[ProfileViews] 📊 Primi 3 viewers:', response.slice(0, 3).map(v => ({
      viewerId: v.viewerUserId,
      viewerUsername: v.viewer?.username,
      viewedAt: v.viewedAt,
      hasPhotos: v.viewer?.photos?.length || 0
    })));
    
    return response;
  } catch (error) {
    console.error('[ProfileViews] ❌ Errore:', error);
    throw error;
  }
}

export async function addProfileView(viewedUserId: number): Promise<void> {
  console.log('[ProfileViews] 📝 Aggiungendo visualizzazione per utente:', viewedUserId);
  console.log('[ProfileViews] 🚀 Prima di chiamare apiRequest');
  
  try {
    const result = await apiRequest('POST', '/api/users/profile-views', { viewedUserId });
    
    console.log('[ProfileViews] 📦 Risultato apiRequest:', result);
    console.log('[ProfileViews] ✅ Visualizzazione aggiunta con successo');
    return result;
  } catch (error) {
    console.error('[ProfileViews] ❌ ERRORE CRITICO nell\'aggiungere visualizzazione:', error);
    console.error('[ProfileViews] ❌ Error type:', typeof error);
    console.error('[ProfileViews] ❌ Error name:', error instanceof Error ? error.name : 'unknown');
    console.error('[ProfileViews] ❌ Error message:', error instanceof Error ? error.message : String(error));
    console.error('[ProfileViews] ❌ Stack trace:', error instanceof Error ? error.stack : 'N/A');
    
    // Re-throw per far vedere l'errore
    throw error;
  }
}
